import { motion } from "framer-motion";
import React from "react";

function Aboutus() {
  // ----------------------------------------------  Animation Variants ----------------------------------------------

  const slideInFromLeft = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0, transition: { duration: 1 } },
  };

  const slideInFromRight = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0, transition: { duration: 1 } },
  };

  const verticalLineAnimation = {
    hidden: { scaleY: 0 },
    visible: { scaleY: 1, transition: { duration: 1, ease: "easeInOut" } },
  };

  // ----------------------------------------------  Animation Variants ----------------------------------------------

  return (
    <div className="w-full min-h-screen bg-cover bg-center flex justify-center items-center text-white overflow-hidden -z-50 lg:mb-[160px] md:mb-[120px] xs:mb-[40px]">
      <div className="lg:w-[calc(100%_-_90px)] xs:w-[calc(100%_-_30px)]">
        {/*  ----------------------- -----------------------bg image of aboutus ----------------------- ----------------------- */}
        <div className="font-faustina h-auto  xs:h-[200px] lg:h-[350px] md:h-[313px] sm:h-[280px]  w-full md:mt-[60px] xs:mt-[40px] bg-aboutus-bg  lg:rounded-[110px] md:rounded-[67px] xs:rounded-[50px] text-white flex flex-col justify-center items-center relative bg-cover bg-center bg-no-repeat">
          <div className="bg-inner absolute inset-0 bg-gradient-to-r from-[#1FA2FF] from-[0%] via-25% to-[#A6FFCB] to-[70%] opacity-20 lg:rounded-[110px] md:rounded-[67px] xs:rounded-[50px]"></div>
          <p className="font-bold md:text-[50px] sm:text-[40px] xs:text-[32px] mb-[10px]">
            Our History
          </p>
          <p className="font-medium text-xl lg:text-[32px] md:text-2xl xs:text-[18px] text-center">
           "Everyone has a past — ours is simply more inspiring. Discover the journey behind Param Group."
          </p>
        </div>

        <div className="w-full font-poppins 1920:mt-[100px] md:mt-[60px] xs:mt-[40px]">
          <div className="relative w-full">
            {/*  ----------------------------------------------card 1 ---------------------------------------------- */}
            <div className="relative flex flex-col  lg:flex-row xs:items-start items-center xs:justify-start ">
              <motion.div
                className="flex flex-col  lg:text-end w-full lg:w-[23%]"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={slideInFromLeft}
              >
                <h2 className="lg:text-[100px] xs:text-[clamp(50px,9.8vw,100px)] font-bold lg:bg-gradient-to-r xs:bg-gradient-to-tl from-[#1FA2FF] from-[70%] to-[#A6FFCB] to-[90%] text-transparent bg-clip-text">
                  01
                </h2>
                <h3 className="1800:text-[50px] 1400:text-[32px] 1200:text-[30px] 1080:text-[28px] lg:text-[26px] xs:text-[clamp(32px,2.9vw,50px)] font-bold lg:bg-gradient-to-r xs:bg-gradient-to-tl from-[#1FA2FF] from-[35%] to-[#A6FFCB] to-[100%] text-transparent bg-clip-text">
                  Who We Are
                </h3>
              </motion.div>
              <div className="flex flex-col lg:flex-col xs:flex-row  xs:justify-center xs:items-center lg:items-center ml-0 lg:ml-5 mt-[24px]">
                <div className="w-10 h-10 rounded-full bg-[#1FA2FF]"></div>
                <motion.div
                  className="line1 w-2  lg:w-2 sm:w-[300px] xs:w-[200px] lg:rounded-b-3xl xs:rounded-e-3xl  bg-gradient-to-b lg:bg-gradient-to-b xs:bg-gradient-to-r from-[#1FA2FF] from-[10%] to-[#A6FFCB] to-[90%]"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.5 }}
                  variants={verticalLineAnimation}
                  style={{
                    transformOrigin: "top",
                  }}
                ></motion.div>
              </div>
              <motion.div
                className="text-lg w-full lg:w-[75%] pl-0 lg:pl-8"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={slideInFromRight}
              >
                <div className="text-justify leading-relaxed flex flex-col gap-5 font-poppins text-lg lg:text-xl whitespace-pre-line px-3 xs:py-4 mt-[15px] ">
                  <p>
                    “At the end of the day, care is a human activity. Technology
                    isn’t meant to replace caregivers, it’s meant to support
                    them.”
                  </p>
                  <p>
                    With a similar vision, Param Group was founded by Mr. Vipul
                    Amin in 2001 to help people access the best healthcare
                    services around them. Param Group was born from a simple
                    idea — to use technology to benefit people’s lives. Our
                    vision drives us to perform exceptional acts and enhance
                    human satisfaction. We, at Param Group, achieve this by
                    offering groundbreaking services in the education,
                    healthcare, and IT industries. Today, we are a celebrated
                    company across the globe, having successfully completed
                    decades of excellence.
                  </p>
                  <p>
                    Committed to finding the best way to offer affordable
                    healthcare services to the community, our founders
                    established the Param Group of Companies. Param Group is the
                    first step toward transforming the healthcare service
                    industry by stepping into education, research, and
                    caregiving. With this, we have successfully catered to
                    thousands of people by providing the best education,
                    healthcare services, and IT solutions. Our beloved clients
                    say that Param Group is not a separate entity but a part of
                    their organization — and that is exactly how they feel once
                    they come onboard.
                  </p>
                </div>
              </motion.div>
            </div>
            {/*  ---------------------------------------------- card2 ----------------------------------------------  */}
            <div className="relative flex flex-col  lg:flex-row xs:items-start items-center xs:justify-start mt-[-5px]">
              <motion.div
                className="flex flex-col  lg:text-end w-full lg:w-[23%] lg:mt-[-25px]"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={slideInFromLeft}
              >
                <h2 className="lg:text-[100px] xs:text-[clamp(50px,9.8vw,100px)] font-bold lg:bg-gradient-to-r xs:bg-gradient-to-tl from-[#1FA2FF] from-[70%] to-[#A6FFCB] to-[90%] text-transparent bg-clip-text">
                  02
                </h2>
                <h3 className="1800:text-[50px] 1400:text-[32px] 1200:text-[30px] 1080:text-[28px] lg:text-[26px] xs:text-[clamp(32px,2.7vw,50px)] font-bold lg:bg-gradient-to-tl xs:bg-gradient-to-tl from-[#1FA2FF] from-[35%] to-[#A6FFCB] to-[100%] text-transparent bg-clip-text ">
                  Our Core Value
                </h3>
              </motion.div>
              <div className="flex flex-col lg:flex-col xs:flex-row  xs:justify-center xs:items-center lg:items-center ml-0 lg:ml-5">
                <div className="w-10 h-10 rounded-full bg-[#1FA2FF]"></div>
                <motion.div
                  className="line2 w-2 lg:w-2 sm:w-[300px] xs:w-[200px] lg:rounded-b-3xl xs:rounded-e-3xl  bg-gradient-to-b lg:bg-gradient-to-b xs:bg-gradient-to-r from-[#1FA2FF] from-[10%] to-[#A6FFCB] to-[90%] "
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.5 }}
                  variants={verticalLineAnimation}
                  style={{
                    transformOrigin: "top",
                  }}
                ></motion.div>
              </div>
              <motion.div
                className="text-lg w-full lg:w-[75%] pl-0 lg:pl-8 "
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={slideInFromRight}
              >
                <div className="text-justify leading-relaxed px-3 py-[12px] flex flex-col gap-5 font-poppins text-lg lg:text-xl whitespace-pre-line">
                  <p>
                    Stronger when ‘UNITED’ <br /> — Like it is said, teamwork
                    makes the dream work — we at Param Group consider employees
                    our greatest resource, helping us achieve milestones. A
                    strong set of core values keeps our workforce responsible to
                    society and guided in the right direction.
                  </p>
                  <div className="flex flex-col gap-2">
                    <p className="text-xl lg:text-2xl font-bold">
                      Unity and Integrity
                    </p>
                    <p>
                      Inspired by the community’s trust in us, we unite as a
                      team to fulfill our clients’ objectives and help them
                      achieve true satisfaction. Setting differences aside, our
                      team works together to support people and improve the
                      environment as a whole. Strong business integrity and
                      ethical honesty in everything we say and do are part of
                      our core values. We believe in actions that reflect both
                      our integrity and our unity within society.
                    </p>
                  </div>
                  <div className="flex flex-col gap-2">
                    <p className="text-xl lg:text-2xl font-bold">
                      Respect for Individuals
                    </p>
                    <p>
                      We respect the honest opinions of individuals working with
                      us and within the community. We maintain confidentiality
                      with every client we work with and treat each person in a
                      way that reflects Param Group’s values. We support
                      individuals with disabilities and empower them in
                      meaningful ways.
                    </p>
                  </div>
                  <div className="flex flex-col gap-2">
                    <p className="text-xl lg:text-2xl font-bold">
                      Loyalty and Trust
                    </p>
                    <p>
                      We strive to be loyal and trustworthy partners for our
                      clients. We share constructive reports and feedback with
                      stakeholders and implement actions that benefit them. We
                      aim to become a reliable partner in the community by
                      making fair, independent, and unbiased decisions.
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>
            {/*  ---------------------------------------------- card3 ----------------------------------------------  */}
            <div className="relative flex flex-col lg:flex-row xs:items-start items-center xs:justify-start mt-[-5px]">
              <motion.div
                className="flex flex-col lg:text-end w-full lg:w-[23%] lg:mt-[-25px]"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={slideInFromLeft}
              >
                <h2 className="lg:text-[100px] xs:text-[clamp(50px,9.8vw,100px)] font-bold lg:bg-gradient-to-r xs:bg-gradient-to-tl from-[#1FA2FF] from-[70%] to-[#A6FFCB] to-[90%] text-transparent bg-clip-text">
                  03
                </h2>
                <h3 className="1800:text-[50px] 1400:text-[32px] 1200:text-[30px] 1080:text-[28px] lg:text-[26px] xs:text-[clamp(32px,2.9vw,50px)] font-bold lg:bg-gradient-to-r xs:bg-gradient-to-tl from-[#1FA2FF] from-[35%] to-[#A6FFCB] to-[100%] text-transparent bg-clip-text">
                  Our Purpose
                </h3>
              </motion.div>
              <div className="flex flex-col lg:flex-col xs:flex-row  xs:justify-center xs:items-center lg:items-center lg:ml-5">
                <div className="w-10 h-10 rounded-full bg-[#1FA2FF]"></div>
                <motion.div
                  className="line w-2 lg:w-2 sm:w-[300px] xs:w-[200px]  xl:h-[480px] 1920:h-[350px] lg:h-[480px] xs:h-2 bg-gradient-to-b lg:bg-gradient-to-b xs:bg-gradient-to-r from-[#1FA2FF] from-[10%] to-[#A6FFCB] to-[90%] lg:rounded-b-3xl xs:rounded-e-3xl"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.5 }}
                  variants={verticalLineAnimation}
                  style={{
                    transformOrigin: "top",
                  }}
                ></motion.div>
              </div>
              <motion.div
                className="text-lg w-full lg:w-[75%] pl-0 lg:pl-8"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={slideInFromRight}
              >
                <div className="text-justify leading-relaxed  px-2 py-[12px] flex flex-col gap-5 font-poppins text-lg lg:text-xl whitespace-pre-line">
                  <p>Care. Cater. Curate</p>
                  <p>
                    Our purpose is very clear and uniquely drives us to fulfill
                    our vision and mission. Care means helping people in our
                    surroundings live better lives. Cater means helping clients
                    and the community solve their problems and achieve better
                    results. And curate means innovating in products and
                    services that take the healthcare industry by storm.
                  </p>
                  <p>
                    Our purpose at Param Group is to devise products and
                    services that not only offer value to the community but also
                    bring contentment in everything we do. Our vision is to
                    combine caregiving and technology in a way that delivers
                    unique and valuable benefits to the community. Driving
                    toward satisfaction is what we consider our primary purpose
                    at the company.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Aboutus;
